import { Separator } from '@/components/ui/separator';
import ClientsHeader from './header';
import MyClientsList from './my-clients-list';

export default function MyClientsPage() {
	return (
		<main className='h-full min-h-0 flex flex-col gap-3 overflow-hidden p-2'>
			<div className='shrink-0'>
				<ClientsHeader />
			</div>
			<Separator className='shrink-0' />
			<div className='flex-1 basis-0 min-h-0'>
				<MyClientsList />
			</div>
		</main>
	);
}
